import React, { FunctionComponent, useContext } from "react";
import { Map } from "../map/component/Map";
import { Infoboard } from "../infoboard/Infoboard";
import { Button } from "../../components/ui/button";
import { CurrentRunContext } from "../../context/CurrentRunContext";
import { RunnerContext } from "../../context/RunnerContext";
import { createRunRepository } from "../../domain/run/RunRepository";

interface Props {}

export const StartRun: FunctionComponent<Props> = () => {
  const { addTrackPoint, startRun, stopRun, pauseRun, isRunning } =
    useContext(CurrentRunContext);
  const { addRun, runs } = useContext(RunnerContext);
  const runRepository = createRunRepository();

  const handleStart = () => {
    isRunning ? pauseRun() : startRun();
  };

  const handleSave = () => {
    stopRun().then((finishedRun) => {
      console.log("Save run");
      if (finishedRun) {
        if (runs.length > 0) {
          runRepository.saveRuns([...runs, finishedRun]);
        } else {
          runRepository.saveRuns([finishedRun]);
        }
        addRun(finishedRun);
      }
    });
  };
  return (
    <div className={"flex flex-col h-full"}>
      <div className={"w-full h-[80px] grow-0"}>
        <Infoboard />
      </div>
      <div className={"w-full grow relative"}>
        <Map />
        <div
          className={
            "absolute h-20 left-0 right-0 bottom-2 flex justify-center gap-6"
          }
        >
          <Button
            variant={"rounded"}
            className={"z-1000 h-20 w-20"}
            onClick={handleStart}
          >
            {isRunning ? "Pause" : "Start"}
          </Button>
          {isRunning && (
            <Button
              variant={"rounded"}
              className={"z-1000 h-20 w-20"}
              onClick={handleSave}
            >
              Stop
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
